import React from 'react';
import { Star, ShieldCheck, Truck, Award } from 'lucide-react';
import { Button } from './ui/Button';
interface StickyCTAProps {
  onCtaClick: () => void;
}
export function StickyCTA({
  onCtaClick
}: StickyCTAProps) {
  const ratings = [{
    stars: 5,
    percentage: 90
  }, {
    stars: 4,
    percentage: 7
  }, {
    stars: 3,
    percentage: 2
  }, {
    stars: 2,
    percentage: 0
  }, {
    stars: 1,
    percentage: 1
  }];
  const handleClick = () => {
    window.location.href = 'https://trynovyrahealth.com/products/novyra%E2%84%A2-daily-balance-kids';
  };
  return <div className="bg-white rounded-2xl shadow-xl border border-slate-200 p-6 sticky top-20" data-id="element-15">
      {/* Headline */}
      <h3 className="font-sans font-bold text-xl text-slate-900 text-center mb-2 leading-tight" data-id="element-16">
        Help Your Child Focus Naturally or Money Back!
      </h3>
      <p className="text-center text-sm text-slate-600 mb-4" data-id="element-17">
        Trusted by 12,000+ Parents
      </p>

      {/* Product Image */}
      <div className="mb-4 flex items-center justify-center" data-id="element-18">
        <img src="https://cdn.magicpatterns.com/uploads/3tPFzMfyTW9JQQZc45bgLA/Ανωνυμο_σχεδιο_(64).png" alt="Novyra Daily Balance Kids Gummies" className="w-full max-w-[280px] rounded-xl" data-id="element-19" />
      </div>

      {/* Star Rating */}
      <div className="mb-4" data-id="element-20">
        <div className="flex items-center justify-center gap-1 mb-2" data-id="element-21">
          {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="#FCD34D" className="text-yellow-400" data-id="element-22" />)}
          <span className="ml-2 font-bold text-slate-900" data-id="element-23">4.8 out of 5</span>
        </div>
        <p className="text-center text-sm text-slate-600 mb-3" data-id="element-24">
          3,791 customer ratings
        </p>

        {/* Rating Breakdown */}
        <div className="space-y-1" data-id="element-25">
          {ratings.map(rating => <div key={rating.stars} className="flex items-center gap-2 text-xs" data-id="element-26">
              <span className="w-8 text-slate-700 font-medium" data-id="element-27">
                {rating.stars}★
              </span>
              <div className="flex-1 bg-slate-200 rounded-full h-2 overflow-hidden" data-id="element-28">
                <div className="bg-yellow-400 h-full rounded-full transition-all duration-500" style={{
              width: `${rating.percentage}%`
            }} data-id="element-29" />
              </div>
              <span className="w-10 text-right text-slate-600 font-medium" data-id="element-30">
                {rating.percentage}%
              </span>
            </div>)}
        </div>
      </div>

      {/* CTA Button */}
      <Button fullWidth size="lg" onClick={handleClick} className="mb-4 shadow-lg shadow-emerald-200" data-id="element-31">
        CHECK AVAILABILITY →
      </Button>

      {/* Trust Badges */}
      <div className="space-y-2 text-xs text-slate-600" data-id="element-32">
        <div className="flex items-center gap-2" data-id="element-33">
          <ShieldCheck size={16} className="text-emerald-600 flex-shrink-0" data-id="element-34" />
          <span data-id="element-35">60-Day Money-Back Guarantee</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-36">
          <Truck size={16} className="text-emerald-600 flex-shrink-0" data-id="element-37" />
          <span data-id="element-38">Limited time offer - Fast FREE shipping</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-39">
          <Award size={16} className="text-emerald-600 flex-shrink-0" data-id="element-40" />
          <span data-id="element-41">Third-Party Tested for Purity</span>
        </div>
      </div>

      {/* Limited Offer Badge */}
      <div className="mt-4 pt-4 border-t border-slate-200 text-center" data-id="element-42">
        <p className="text-xs font-bold text-red-600 uppercase tracking-wide" data-id="element-43">
          ⚡ Limited Time: 30% OFF
        </p>
      </div>
    </div>;
}